export const evidenceIconMap: Record<string, string> = {
  截图证据: "ri-image-line",
  录音证据: "ri-mic-line",
  文字记录: "ri-file-text-line",
  视频素材: "ri-video-line",
  时间线: "ri-timeline-view",
  关联方: "ri-links-line",
};

export const statusStyleMap: Record<string, string> = {
  持续更新: "bg-accent-100 text-accent-300 border-accent-300/50",
  整理中: "bg-primary-100 text-primary-300 border-primary-300/50",
  已归档: "bg-secondary-100 text-secondary-300 border-secondary-300/50",
};

export function getEvidenceIcon(type: string): string {
  return evidenceIconMap[type] ?? "ri-file-line";
}

export function formatDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
}

export function formatShortDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${Number(parts[1])}/${Number(parts[2])}`;
}